import {CaretDownOutlined, DownOutlined} from '@ant-design/icons';
import {Menu, Popover} from 'antd';
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
// import { useSession } from 'Shared/hooks';
// import { CompaniesFilterOption, GlobalFilterAtom, GlobalFilterAtomType, LogisticProvider, LogisticProviderFilterOption } from 'Recoil/global_filter.atom';
import { GlobalFilterAtom, GlobalFilterAtomType } from 'Recoil/global_filter.atom';
import './global-filter.scss';
import {isArray, isEmpty, isNil, map, omitBy, set} from "lodash";
import { getCompanyList, getLogisticProviderList } from 'Services/account.services';
import { useSession } from 'Hooks/index';
import { AccountRole } from 'Types/common.types';
import { optionalize } from 'Helpers/optionalize';
import { Option } from 'Types/common.types';
// sample data
import GlobalFilterSampleData from "./global-filter-data-sample.json";
import { fetchOrgGlobalFilterOptions } from 'Services/global-filter.services';

interface GlobalFilterOptionObject {
  id:string;
  name:string;
  color:string;
  children:GlobalFilterOptionObject[];
}

const GlobalFilter = ({ children }: any) => {
  const { org } = useSession();
  const { t } = useTranslation();
  const history = useHistory();

  const [globalFilterState, setGlobalFilterState] = useRecoilState(GlobalFilterAtom);
  const [selectedFilter, setSelectedFilter] = useState<any>({});
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [filterList, setFilterList] = useState<GlobalFilterOptionObject[]>([]);
  const globalFilterLocal = localStorage.getItem("globalFilter");


  useEffect(()=>{
    if(globalFilterLocal && isEmpty(selectedFilter)){
      let savedGlobalFilter = JSON.parse(globalFilterLocal)
      setSelectedFilter(savedGlobalFilter.selectedOrgName)
      setGlobalFilterState(savedGlobalFilter)
    }
  },[globalFilterLocal])


  useEffect(()=>{
    if(!isEmpty(selectedFilter)){
      let globalFilState = {
        ...globalFilterState,
        selectedOrgName: selectedFilter,
        selectedOrgIDs: globalFilterState.companyIds || globalFilterState.logisticsProviderIds
      }
      localStorage.setItem('globalFilter', JSON.stringify(globalFilState))
    }
  },[selectedFilter, globalFilterState])

  useEffect(() => {
    if(isEmpty(filterList) && org?._id){
      fetchGlobalFilterOptions();
    }else{
      !globalFilterLocal && handleSelectAll();
    }
  }, [filterList,org._id])

  const handleSelectChange = (optObj:GlobalFilterOptionObject) => {
    setSelectedFilter(optObj.name);
    if (isEmpty(optObj.children)) {
      let companyIds = optObj.id == "*" ? map(optObj.children, 'id') : [optObj.id];
      setGlobalFilterState({companyIds: companyIds, __isInitializing__: false, selectedOrgIDs: companyIds })
    } else{
      setGlobalFilterState({logisticsProviderIds: [optObj.id], __isInitializing__: false, selectedOrgIDs: [optObj.id] })
    }
    setPopoverVisible(false)
  };

  const handleSelectAll = (optObj?:GlobalFilterOptionObject) => {
    let idArr:string[] = [];
    const atomFieldName: keyof GlobalFilterAtomType = org.orgType === AccountRole.LOGISTIC_PROVIDER ? 'companyIds' : 'logisticsProviderIds'

    if(optObj){
      setSelectedFilter(optObj.name);
      idArr = [...idArr,optObj.id]
    } else {
      setSelectedFilter('ALL');
      filterList.forEach((filter)=>{
        idArr = [...idArr, filter.id]
      })
    }
    setGlobalFilterState({
      [atomFieldName] :idArr,
      selectedOrgIDs: idArr,
      __isInitializing__: false
    })
    setPopoverVisible(false)
  };

  const fetchGlobalFilterOptions = async () => {
    const responseData = await fetchOrgGlobalFilterOptions(org?._id);

    if(responseData && !responseData.error){
      setFilterList(responseData)
    }
  }

  // follow up on subsequent pages that subscribed global filter

  const popoverContent = (
    <div className="mod-host__supplier-ecom-platform-selector__popover">
      <Menu mode="inline">
        {filterList.length >= 1 && <Menu.Item onClick={() => handleSelectAll()} key={'ALL'} icon={<span className="half-square" style={{ borderTop: `12px solid transparent` }}></span>}>
          <span className={`half-square`} style={{ borderTop: `12px solid grey` }}></span> {'ALL'}
        </Menu.Item>}
        {filterList.map(w => (
          w.children ?
            <Menu.SubMenu title={w.name} icon={<span className="half-square" style={{borderTop: `12px solid ${w.color}`}}></span>}>
              <Menu.Item  onClick={()=>handleSelectAll(w as GlobalFilterOptionObject)} key={w.name} icon={<span className="half-square" style={{borderTop: `12px solid ${w.color}`}}></span>}>
                All
              </Menu.Item>
              {w?.children.map(sub => (
                <Menu.Item  onClick={()=>handleSelectChange(sub as GlobalFilterOptionObject)} key={sub.name} icon={<span className="half-square" style={{borderTop: `12px solid ${w.color}`,
                borderRight: `12px solid ${sub.color}`}}></span>}>
                  {sub.name}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
            :
            <Menu.Item onClick={()=>handleSelectChange(w as GlobalFilterOptionObject)} key={w.name} icon={<span className={`half-square`} style={{borderTop: `12px solid ${w.color}`}}></span>}>
              {w.name}
            </Menu.Item>
        ))}
      </Menu>
    </div>
  );

  const handleVisibleChange = (newVisible: boolean) => {
    if(!filterList.length){
      fetchGlobalFilterOptions()
    }
    setPopoverVisible(newVisible);
  };

  return (
    <div className="mod-host__supplier-ecom-platform-selector">
      <Popover
        placement="bottomRight"
        className="ecom-selector-popover"
        content={popoverContent}
        trigger={['click']}
        align={{ offset: [0, -8] }} // * @see https://github.com/ant-design/ant-design/issues/20378
        visible={popoverVisible}
        onVisibleChange={handleVisibleChange}
        // @see https://github.com/ant-design/ant-design/issues/3448#issuecomment-255918204
        getPopupContainer={triggerNode => triggerNode?.parentNode as HTMLElement}
      >
        <div className="mod-host__supplier-ecom-platform-selector__logo">
          {!isEmpty(selectedFilter) ? selectedFilter : "ALL"}
        </div>
        <DownOutlined className='mod-host__supplier-ecom-platform-selector__down-arrow'/>
      </Popover>

      {children}
    </div>
  );
};

export default GlobalFilter;
